<template>
    <button
        v-if="rating && formattedRating"
        type="button"
        class="inline-flex items-center gap-2 whitespace-nowrap focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current"
        :aria-label="ariaLabel"
        @click="openReviews"
    >
        <MiscStarRating />

        <span class="font-semibold">{{ formattedRating }}</span>

        <MiscIcon name="trusted-shops" size="md" />

        <MiscIcon name="chevron-right" size="md" />
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTrustedShops } from '#imports'

const { t, locale } = useI18n()
const { rating, formattedRating, ratingLabelKey } = useTrustedShops()
const { toggleModal } = useModal()

const openReviews = function () {
    toggleModal('trustedShops', null)
}

const ariaLabel = computed(() => {
    if (!rating.value) {
        return ''
    }

    return t('layout.promobar.ratingAriaLabel', {
        grade: ratingLabelKey.value ? t(`layout.promobar.ratingLabels.${ratingLabelKey.value}`) : '',
        rating: formattedRating.value,
        count: new Intl.NumberFormat(locale.value).format(rating.value.count)
    })
})
</script>
